import { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import TargetsEquipmentTable from './TargetsEquipmentTable';

const LinkTypes = [
  'FEEDS',
  'CONTAINS',
  'CONTROLS',
  'FULLY_AGGREGATES',
  'HAS_PART',
  'HAS_RANGE',
  'MEASURES',
  'MEASURES_TYPE',
  'PARIALLY_AGGREGATES',
];

const TargetsEquipment = ({ building, stagingEquipment, equipment }) => {
  const [linkType, setLinkType] = useState(LinkTypes[0]);
  return (
    <>
      <Autocomplete
        options={LinkTypes}
        onChange={(_event, lt) => setLinkType(lt)}
        value={linkType}
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderInput={(params) => <TextField label="Select Connection" {...params} />}
      />
      <TargetsEquipmentTable
        key={linkType}
        linkType={linkType}
        linkTypes={LinkTypes}
        building={building}
        equipment={equipment}
        stagingEquipment={stagingEquipment}
      />
    </>
  );
};

export default TargetsEquipment;
